import addPopover from "../dom/addPopover";

export default function add3dPopOver() {
	addPopover(
		"3d",
		".pplr-3d-lift-10",
		"3D",
		'<img src="https://cdn.shopify.com/s/files/1/0324/9592/7429/files/3D-Puff-V3.gif?v=1649993400" width="153" height="117" style="width:100%" />',
		"right",
		"ml-2",
	);
}
